import * as React from 'react';
import * as styles from './Dialog.module.scss';
import { Logo, LogoOptions } from '@amzn/dvui/dist/Logo'
import * as cn from 'classnames'
import { AnswerList } from './AnswerList'
import { Question } from '../model/model';

export interface feedbackDialogProps {
    question: Question,
    submitAction: Function
}

export class  FeedbackDialog extends React.Component<feedbackDialogProps> {
    constructor(props: feedbackDialogProps) {
        super(props)
    }

    render() {
        const goAway = () => this.props.submitAction(-1)
        // Todo: [AVWebStorefront-1866] Use localised strings from
        // DVWebFeedbackService when they are available.
        const goAwayLabel = this.props.question.goAwayLabel
        const explanation = this.props.question.explanationLabel
        return (
            <div className={cn(styles.feedbackContainer,
                "avu-section-alt", "dvui-section-alt")}>
                <Logo use={LogoOptions.brand} />

                <span className={styles.explanation}>{explanation}</span>
                <h2 className={styles.questionLabel}>{this.props.question.label}</h2>
                <AnswerList answers={this.props.question.answers} submitAction={this.props.submitAction} />
                <button className={styles.noAnswer} onClick={goAway}>
                    {goAwayLabel}
                </button>
            </div>

        );
    }
}